<p>user-invite works!</p>
